import React from 'react'
import { Button, Alert, Dialog, DialogActions, FormControl, DialogContent, DialogTitle, Divider, Typography, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const AddCarRppbDialog = ({
    openCarRppbModal,
    setOpenCarRppbModal,
    reportingEntityName,
    setReportingEntityName,
    setStartDate,
    setEndDate,
    handleSubmitCarRppb,
    setCarRppbError,
    carRppbError }) => {

    return (
        <Dialog
            open={openCarRppbModal}
            onClose={() => setOpenCarRppbModal(false)}
            sx={{ '& .MuiDialog-paper': { width: '500px', maxWidth: '500px' } }} // Set fixed width
        >
            {/* {console.log(carRppbError, 'carRppbError')} */}
            <DialogTitle>Add New CAR Rppb</DialogTitle>
            <Alert severity='warning' sx={{ width: 'auto', }}>
                This action will create a new Car Reporting Period Project Bundle
            </Alert>
            <DialogContent>
                <Divider sx={{ my: 1 }} />
                <Typography>Reporting Entity Name</Typography>
                <TextField
                    name='nickname'
                    value={reportingEntityName}
                    onChange={e => setReportingEntityName(e.target.value)}
                    fullWidth
                    sx={{ mb: 2 }}
                />
                {carRppbError.name && <Alert sx={{ mb: 1, width: '100%' }} severity="error">{carRppbError.name}</Alert>}
                <FormControl fullWidth sx={{ mb: 2 }}>
                    Start Date
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker name="Start Date"
                            // onChange={(e) => handleInputChange(e, field.name)} 
                            onChange={(e) => setStartDate(e)}
                        />
                    </LocalizationProvider>
                </FormControl>
                {carRppbError.start && <Alert sx={{ mb: 1, width: '100%' }} severity="error">{carRppbError.start}</Alert>}
                <FormControl fullWidth sx={{ mb: 2 }}>
                    End Date
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker name="Start Date"
                            // onChange={(e) => handleInputChange(e, field.name)} 
                            onChange={(e) => setEndDate(e)}
                        />
                    </LocalizationProvider>
                </FormControl>
                {carRppbError.end && <Alert sx={{ mb: 1, width: '100%' }} severity="error">{carRppbError.end}</Alert>}
            </DialogContent>
            <DialogActions sx={{ mr: 'auto', mb: 3, ml: 2 }}>
                <Button variant='contained' onClick={handleSubmitCarRppb}>
                    Add
                </Button>
                <Button variant='outlined' onClick={() => { setCarRppbError({ name: null, start: null, end: null }); setOpenCarRppbModal(false) }}>
                    Cancel
                </Button>

            </DialogActions>
        </Dialog>
    )
}

export default AddCarRppbDialog